export { helpHero, initHelpHero } from './helphero';
export type { HelpHeroUserTraits } from './helphero';
